import { Identifiable } from '@approvalmax/types';

import { messages } from './DropdownEditor.messages';

/**
 * This function takes an array of items and an optional array of ids.
 * It maps through the items, adding a 'subText' property to those whose id is included in the ids array,
 * and then sorts the array so that the items with ids in the ids array come first.
 *
 * @param {Identifiable[]} items - The array of items to process.
 * @param {string[]} [ids=[]] - The array of ids to prioritize.
 * @returns {Identifiable[]} - The new sorted array of items.
 */
export const prioritizeAndMapDropdownItems = <T extends Identifiable>(items: T[], ids: string[] = []) => {
    const prioritizedItems = ids.reduce((accumulator, currentValue) => {
        const itemIndex = items.findIndex((item) => item.id === currentValue);

        if (itemIndex !== -1) {
            return [...accumulator, { ...items[itemIndex], subText: messages.suggestedItemText }];
        }

        return accumulator;
    }, []);

    const nonPrioritizedItems = items.filter((item) => !ids.includes(item.id));

    return [...prioritizedItems, ...nonPrioritizedItems];
};
